import { render, staticRenderFns } from "./ProductContainerNoCliente.vue?vue&type=template&id=80c0335c&scoped=true"
import script from "./ProductContainerNoCliente.vue?vue&type=script&lang=js"
export * from "./ProductContainerNoCliente.vue?vue&type=script&lang=js"
import style0 from "./ProductContainerNoCliente.vue?vue&type=style&index=0&id=80c0335c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c0335c",
  null
  
)

export default component.exports